import { Plugin } from './plugin';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { TelephonyService } from 'rainbow-web-sdk/services/telephony/telephony.service';

export class TelephonyPlugin extends Plugin {
    public static initialize(): void {
        Plugin.initialize();
        if (!window.rainbow.plugins[TelephonyPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[TelephonyPlugin] initialized");
            window.rainbow.plugins[TelephonyPlugin.name] = new TelephonyPlugin();
            TelephonyService.getInstance();
        }
    }

    private constructor() {
        super();
    }
}
